export const FEATURED_COLOR = '#6448F1';
export const FEATURED_COLOR_HOVER = '#5338E1';
export const FEATURED_TITLE_COLOR = '#C0B4FB';
